<template><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 248 262">
  <g id="colorchange">
    <g>
      <polygon class="itembackground" fill="#00002f" fill-opacity="0.6" points="2.5 259.5 2.5 40.95 40.95 2.5 245.5 2.5 245.5 221.05 207.05 259.5 2.5 259.5"/>
      <path class="itemoutline" fill="#98b8ff"
d="M243,5V220l-24,24-13,13H5V42L23.5,23.5,42,5H243m5-5H39.91C24.33,15.59,15.59,24.33,0,39.91V262H208.09c15.58-15.59,24.32-24.33,39.91-39.91V0Z"/>
    </g>
  </g>
</svg>
</template>